import { createElement } from "../create-element";
const submenuCartEl = document.querySelector("[data-shop-submenu-cart-link]");
const basketItemsCountEl = document.querySelector("[data-basket-items-count]");

if (submenuCartEl) {
  const iconEl = createElement("ui-icon", { attributes: { icon: "cart-32", size: 32 } });
  const bubbleEl = createElement("div", { classes: "bubble" });

  submenuCartEl.title = submenuCartEl.innerText;
  submenuCartEl.innerHTML = "";

  if (basketItemsCountEl) {
    bubbleEl.innerText = basketItemsCountEl.dataset.basketItemsCount;
  }

  submenuCartEl.appendChild(iconEl);
  submenuCartEl.appendChild(bubbleEl);

  // const navbarActionsEl = document.querySelector(".navbar-actions");
  // if (navbarActionsEl) {
  //   const headerBubbleEl = submenuCartEl.cloneNode(true);
  //   navbarActionsEl.appendChild(headerBubbleEl);
  // }

  document.addEventListener("addItem:end", (e) => {
    if (e.detail && e.detail.items !== "undefined") {
      const bubbleEls = document.querySelectorAll("[data-shop-submenu-cart-link] .bubble");
      const items_count = e.detail.items;
      bubbleEls.forEach((bubbleEl) => {
        bubbleEl.innerText = items_count;
      });
    }
  });
}
